import Home from '@/views/Home.vue';
import NotFound from '@/views/NotFound.vue';
import { h } from 'vue';
import { RouteRecordRaw, RouterView } from 'vue-router';

const routes = [
  {
    path: '/',
    component: { render: () => h(RouterView) },
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: '',
        component: Home,
      },
    ],
  },
  {
    path: '/:pathMatch(.*)*',
    component: NotFound,
  },
] as RouteRecordRaw[];

export default routes;
